<mat-card *ngIf="venue" appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1 i18n>Edit {{ venue.doc.name }}</h1>
      <eas-translation-info-list *ngIf="venue.doc.translationInfo"
                                 [translationInfo]="venue.doc.translationInfo">
      </eas-translation-info-list>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form *ngIf="easFormGroup$ | async; let group; else loading" [formGroup]="group.control">
      <div class="form-container">
        <eas-easform-group [easGroup]="group">
        </eas-easform-group>
      </div>
    </form>
    <ng-template #loading>
      <div *ngIf="!error" i18n>Loading ...</div>
      <div *ngIf="error">{{ error }}</div>
    </ng-template>
  </mat-card-content>
  <mat-card-actions align="start">
    <button mat-flat-button color="primary" type="submit" (click)="onSubmit()" i18n>Submit</button>
  </mat-card-actions>
</mat-card>